import { createRouter, createWebHistory } from 'vue-router'
const HomePage = () => import('./pages/HomePage.vue')
const PrivacyPage = () => import('./pages/PrivacyPage.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'HomePage',
      path: '/',
      component: HomePage
    },
    {
      name: 'PrivacyPage',
      path: '/privacy',
      component: PrivacyPage
    },
  ]
})

export default router
